export default "dist/images/components-image-shape-control-circle.ddaef4e.png";